import { render } from "./Shippings.vue?vue&type=template&id=dc58ec10"
import script from "./Shippings.vue?vue&type=script&lang=js"
export * from "./Shippings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__